export const CREATE_OR_UPDATE_TODO = "todo/CREATE_OR_UPDATE_TODO";
export const CREATE_OR_UPDATE_TODO_SUCCESS = "todo/CREATE_OR_UPDATE_TODO_SUCCESS";
export const CREATE_OR_UPDATE_TODO_ERROR = "todo/CREATE_OR_UPDATE_TODO_ERROR";

export const GET_TODO = "todo/CREATE_OR_UPDATE_TODO_ERROR";
export const GET_TODO_SUCCESS = "todo/GET_TODO_SUCCESS";
export const GET_TODO_ERROR = "todo/GET_TODO_ERROR";